<script lang="ts">
  import {envUtil} from '@/helper/env.js';
  import {remoteHeader$} from '@/resource/streams';
  import {lang$} from '@/store/lang';
  import {BehaviorSubject, Observable} from 'rxjs';
  import {mc} from '@/core';
  import {isLogin$} from '@/store/user';
  import {totalAssets$} from '@/streams/assets/total-assets';
  import {
    contractMarkets$,
    marginMarkets$,
    pilotContractMarkets$,
    spotMarkets$,
  } from '@/modules/markets/streams-market';
  import {loadAssetsOverviewData$} from '@/streams/data/assets';
  import {logout$} from '@/streams/auth';
  import {importantAnnouncementHeight$} from '@/modules/header/stream';

  const langObservable$ = new Observable<string>((subscriber) => {
    const unsubscribe = lang$.subscribe((value) => {
      subscriber.next(value);
    });
    return () => unsubscribe();
  });

  export let isVisible = true;

  let headerEle: HTMLDivElement;
  let headerHeight = 0;

  $: envUtil.isBrowser &&
    renderHeader({
      container: headerEle,
      sdk: $remoteHeader$,
    });
  $: getHeaderOffsetTop(headerHeight, 56);

  function renderHeader({container, sdk}) {
    if (container && sdk) {
      sdk?.mountHeader({
        container,
        lang$: langObservable$,
        theme$: new BehaviorSubject('dark'),
        isLogin$,
        setLanguage,
        // userProfileState$,
        totalAssets$,
        refreshTotalAssets,
        logout,
        contractMarkets$,
        pilotContractMarkets$,
        marginMarkets$,
        spotMarkets$,
        mc
      });
    }
  }

  function setLanguage(lang) {
    lang$.set(lang);
  }

  function refreshTotalAssets() {
    loadAssetsOverviewData$.next();
  }

  function logout(e) {
    e?.stopPropagation();
    logout$.next({manual: true});
  }

  function getHeaderOffsetTop(headerHeight: number, defaultHeight: number) {
    if(headerHeight >=0 ){
      importantAnnouncementHeight$.next(headerHeight > defaultHeight ? headerHeight - defaultHeight : 0);
    }
  }
</script>

<style>
  .header-place {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 10000;
    width: 100%;
    height: auto;
    /*min-height: 56px;*/
  }
  .header-place.visibleHidden {
    visibility: hidden;
  }

  @media screen and (max-width: 640px) {
    .header-place {
      height: unset;
      min-height: unset;
    }
  }
</style>

<div class="header-place" class:visibleHidden={!isVisible} bind:this={headerEle} bind:offsetHeight={headerHeight}/>
